import { render, staticRenderFns } from "./volunteerB.vue?vue&type=template&id=07d9ec29&scoped=true&"
import script from "./volunteerB.vue?vue&type=script&lang=js&"
export * from "./volunteerB.vue?vue&type=script&lang=js&"
import style0 from "./volunteerB.vue?vue&type=style&index=0&id=07d9ec29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d9ec29",
  null
  
)

export default component.exports